import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import { gsap } from 'gsap';
import axiosPlugin from '@/plugins/axios';
import AOS from 'aos';

import App from './App.vue';
// import './registerServiceWorker';
import router from './router';
import store from './store';
import '@/assets/scss/main.scss';
import 'aos/dist/aos.css';
import 'plyr/dist/plyr.css';

const app = createApp(App);

app.use(router);
app.use(store);
app.use(axiosPlugin);
store.$axios = axiosPlugin;
app.use(VueLazyload);

app.config.globalProperties.$gsap = gsap;

app.mount('#app');

AOS.init({
  disable: false,
  duration: 600,
  easing: 'ease-in-out-cubic',
  once: true,
  offset: 0,
});
